import { useContext, useEffect } from 'react'

import {
  Box,
  Button,
  Input,
  Modal,
  Text,
  TextArea,
} from '@fairfashion/design-system'
import { useForm } from 'react-hook-form'

import { QRCodeDetailsContext } from '../../qrcode-details.context'

import {
  QRCodeDetailsFeedstockForm,
  QRCodeDetailsFeedstockFormModalProps,
} from './qrcode-details-feedstock-form-modal.types'

export const QRCodeDetailsFeedstockFormModal = ({
  partId,
  defaultValues,
  open,
  onClose,
}: QRCodeDetailsFeedstockFormModalProps) => {
  const { actions } = useContext(QRCodeDetailsContext)

  const { register, reset, handleSubmit } =
    useForm<QRCodeDetailsFeedstockForm>()

  useEffect(() => {
    if (open) {
      if (defaultValues) {
        reset({
          code: defaultValues.code,
          composition: `${defaultValues.composition}`,
          name: defaultValues.name,
          description: defaultValues.description,
        })

        return
      }

      reset({
        code: '',
        composition: '',
        name: '',
        description: '',
      })
    }
  }, [open, reset])

  const onSubmit = async (data: QRCodeDetailsFeedstockForm) => {
    if (!partId) return

    await actions.saveFeedstockItemProfile(partId, data)

    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Matéria-prima"
      width="800px"
      maxWidth="90%"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box width="100%" direction="column" gap={3}>
          <Box width="100%" direction="column" gap={2}>
            <Box gap={2} width="100%">
              <Box flex={1}>
                <Input
                  label="Código"
                  {...register('code')}
                  disabled={!!defaultValues}
                />
              </Box>
              <Box flex={1}>
                <Input
                  label="Composição"
                  type="number"
                  adornment={<Text color="grey_3">%</Text>}
                  adornmentPosition="right"
                  {...register('composition')}
                />
              </Box>
            </Box>
            <Box width="100%">
              <Input label="Nome" {...register('name')} required />
            </Box>
            <Box width="100%">
              <TextArea label="Descrição" {...register('description')} />
            </Box>
          </Box>

          <Box width="100%" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={onClose} padding="10px 16px">
              <Text size="small" fontWeight={500}>
                Cancelar
              </Text>
            </Button>
            <Button padding="10px 16px" type="submit">
              <Text size="small" fontWeight={500} color="white">
                Salvar
              </Text>
            </Button>
          </Box>
        </Box>
      </form>
    </Modal>
  )
}
